import * as yup from "yup";

import { AutocompleteItem } from "../../../../components/Autocomplete";
import { FormId } from "../../../../components/enums";
import { defaultCountry } from "../../../../shared";
import { requiredMessage } from "../../../../utilities/validationMessages";
import {
  countryValidatorRequired,
  dateValidatorRequired,
  provinceValidatorRequired,
  textareaValidatorRequired,
  timeValidatorRequired,
} from "../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_CIRCUMSTANCES]: yup.object({
    [ComponentId.INCIDENT_CIRCUMSTANCES_DATE]: dateValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_HOUR]: timeValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_PLACE]: textareaValidatorRequired(250),
    [ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY]: countryValidatorRequired,
    [ComponentId.INCIDENT_CIRCUMSTANCES_PROVINCE]: yup
      .string()
      .when(ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY, {
        is: (country: AutocompleteItem) =>
          country?.value === defaultCountry.value,
        then: provinceValidatorRequired,
      }),
    [ComponentId.INCIDENT_CIRCUMSTANCES_ZIP_CODE_PL]: yup
      .string()
      .when(ComponentId.INCIDENT_CIRCUMSTANCES_COUNTRY, {
        is: (country: AutocompleteItem) =>
          country?.value === defaultCountry.value,
        then: () =>
          yup
            .string()
            .required(requiredMessage)
            .matches(/^\d{2}-\d{3}$/, requiredMessage),
        otherwise: () => yup.string().notRequired(),
      }),
    [ComponentId.INCIDENT_CIRCUMSTANCES_CITY]: yup
      .mixed()
      .test("city-required-generic", requiredMessage, (v) => {
        if (v == null) return false;
        if (typeof v === "string") return v.trim().length > 0;
        if (typeof v === "object") {
          const s = String((v as any).label ?? (v as any).value ?? "").trim();
          return s.length > 0;
        }
        return false;
      }),
    [ComponentId.INCIDENT_CIRCUMSTANCES_DESCRIPTION]:
      textareaValidatorRequired(10000),
  }),
};
